import { render, staticRenderFns } from "./IconBaths.vue?vue&type=template&id=684a67ae&"
import script from "./IconBaths.vue?vue&type=script&lang=js&"
export * from "./IconBaths.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports